import { render, staticRenderFns } from "./novedades_institucion.vue?vue&type=template&id=b1b9fb08&scoped=true"
import script from "./novedades_institucion.vue?vue&type=script&lang=js"
export * from "./novedades_institucion.vue?vue&type=script&lang=js"
import style0 from "./novedades_institucion.vue?vue&type=style&index=0&id=b1b9fb08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b9fb08",
  null
  
)

export default component.exports